<template>
  <div class="coherence-gauge">
    <div class="gauge-container">
      <!-- Échelle de pourcentages à gauche -->
      <div class="gauge-scale">
        <div class="scale-item" v-for="mark in scaleMarks" :key="mark">
          <span class="scale-label">{{ mark }}%</span>
        </div>
      </div>
      
      <!-- Jauge verticale -->
      <div class="gauge-bar">
        <!-- Dégradé de fond complet -->
        <div class="gauge-background"></div>
        
        <!-- Indicateur de niveau (trait + bulle) inversé -->
        <div 
          class="gauge-indicator-container" 
          :style="{ top: (100 - coherencePercentage) + '%' }"
        >
          <!-- Trait horizontal -->
          <div class="gauge-indicator"></div>
          
          <!-- Bulle avec la valeur -->
          <div class="gauge-bubble">
            <span class="bubble-value">{{ Math.round(coherenceValue) }}%</span>
            <div class="bubble-arrow"></div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Titre en bas -->
    <!-- <h3 class="bottom-title">Cohérence Cardiaque</h3> -->
  </div>
</template>

<script>
export default {
  name: "CoherenceCardiaqueGauge",
  props: {
    coherenceValue: {
      type: Number,
      default: 0,
      validator: (value) => value >= 0 && value <= 100
    }
  },
  data() {
    return {
      scaleMarks: [100, 80, 60, 40, 20, 0]
    };
  },
  computed: {
    coherencePercentage() {
      return Math.max(0, Math.min(100, this.coherenceValue));
    }
  }
};
</script>

<style scoped>
.coherence-gauge {
  border-radius: 8px;
  padding: 15px; /* Même padding que le guide respiratoire */
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.gauge-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  flex: 1;
  flex-direction: row; /* Override pour garder l'échelle à côté */
}

/* Échelle à gauche */
.gauge-scale {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 190px; /* Même hauteur que la jauge */
  padding: 2px 0;
  margin-right: 10px;
  margin-top: 70px; /* Marge pour aligner avec la jauge */
}

.scale-item {
  display: flex;
  align-items: center;
  height: 0;
}

.scale-label {
  font-size: 12px;
  color: #666;
  font-weight: 500;
  min-width: 35px;
  text-align: right;
}

/* Jauge verticale rectangulaire - MÊMES DIMENSIONS que le guide respiratoire */
.gauge-bar {
  position: relative;
  width: 50px; /* Largeur légèrement réduite */
  height: 190px; /* Hauteur légèrement augmentée */
  background-color: #eee; /* Même fond que la jauge respiratoire */
  border-radius: 15px 15px 0 0; /* Même border-radius que la jauge respiratoire */
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2); /* Même ombre que la jauge respiratoire */
  overflow: visible;
  margin-top: 70px; /* Marge de 70px */
}

.gauge-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to top,
    #ff0000 0%,    /* Rouge pur en bas */
    #ff4500 16.66%, /* Rouge-orange */
    #ffa500 33.33%, /* Orange */
    #ffff00 50%,    /* Jaune */
    #9acd32 66.66%, /* Vert-jaune */
    #008000 100%    /* Vert pur en haut */
  );
  border-radius: 15px 15px 0 0; /* Même border-radius que la jauge respiratoire */
}

.gauge-indicator-container {
  position: absolute;
  left: -5px;
  width: 100px;
  height: 3px;
  transition: top 0.6s ease-out;
  z-index: 10;
}

.gauge-indicator {
  width: 60px; /* Ajusté pour la nouvelle largeur */
  height: 3px;
  background-color: #000;
  border-radius: 1px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
}

.gauge-bubble {
  position: absolute;
  left: 65px; /* Ajusté pour la nouvelle largeur */
  top: -18px;
  background-color: #333;
  color: white;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  z-index: 20;
}

.bubble-value {
  line-height: 1;
}

.bubble-arrow {
  position: absolute;
  left: -5px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-right: 5px solid #333;
}

/* Style pour le titre placé en bas - MÊME STYLE que le guide respiratoire */
.bottom-title {
  text-align: center;
  color: #333;
  margin-top: auto;
  margin-bottom: 0;
  padding-top: 15px;
  font-size: 16px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .coherence-gauge {
    padding: 12px;
  }
  
  .gauge-scale {
    height: 150px;
    margin-right: 8px;
  }
  
  .gauge-bar {
    width: 45px;
    height: 150px;
  }
  
  .scale-label {
    font-size: 11px;
    min-width: 30px;
  }
  
  .gauge-indicator {
    width: 55px;
  }
  
  .gauge-bubble {
    left: 60px;
    padding: 4px 8px;
    font-size: 11px;
  }
  
  .bottom-title {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .gauge-scale {
    height: 120px;
  }
  
  .gauge-bar {
    width: 35px;
    height: 120px;
  }
  
  .gauge-indicator {
    width: 45px;
  }
  
  .gauge-bubble {
    left: 50px;
    padding: 3px 6px;
    font-size: 10px;
  }
  
  .scale-label {
    font-size: 10px;
    min-width: 25px;
  }
  
  .bottom-title {
    font-size: 13px;
  }
}
</style>